import { render } from "./OTPInput.vue?vue&type=template&id=e7a9a8b0&scoped=true"
import script from "./OTPInput.vue?vue&type=script&lang=js"
export * from "./OTPInput.vue?vue&type=script&lang=js"

import "./OTPInput.vue?vue&type=style&index=0&id=e7a9a8b0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3339443357/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7a9a8b0"]])

export default __exports__